import { useMutation } from "@tanstack/react-query";
import { preBookAppointment } from "../../../services/doctors";
import { useToast } from "../../../components/ui/use-toast";
import { AxiosError } from "axios";

type ApiErrorResponse = {
  message?: string;
  description?: string;
  bookingId?: number;
  appointmentType?: "WALK_IN" | "TELECONSULTATION";
};

export function usePreBookAppointment(
  onConflict?: (data: ApiErrorResponse) => void,
  onSuccess?: () => void
) {
  const { toast } = useToast();

  const { mutate, isPending } = useMutation({
    mutationFn: preBookAppointment,
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error: AxiosError<ApiErrorResponse>) => {
      if (error.response?.status === 409) {
        // Pass the error response data to onConflict
        onConflict?.(error.response.data);
        return;
      }

      toast({
        title: "Failed to pre book appointment",
        description:
          error?.response?.data?.description ||
          error?.response?.data?.message ||
          "Something went wrong",
        variant: "destructive",
      });
    },
  });

  return { preBookAppointment: mutate, isInProgess: isPending };
}